export const SESSION_STORAGE_KEYS = {
  scheduleModuleState: 'scheduleModuleState',
};
